export const thunkTypes = {
  LIST_REFERRALS: `referrals/listReferrals`,
  CREATE_REFERRAL: `referrals/createReferral`,
  GET_ORIGINATION_URL: `referrals/getOriginationUrl`,
  GET_REFERRAL_CODE: `referrals/getReferralCode`,
};
